import React from 'react';
import { Box, Typography, Grid, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

// Exact same styled components as Contact homepage footer
const BlueSection = styled(Box)({
  backgroundColor: '#4169E1',
  padding: '40px 0',
  color: 'white',
  marginTop: '60px'
});

const BlueGrid = styled(Grid)({
  width: '90%',
  margin: '0 auto'
});

const BlueBox = styled(Box)({
  padding: '20px',
  textAlign: 'left',
  '& h3': {
    fontSize: '24px',
    marginBottom: '15px',
    fontWeight: '500'
  },
  '& p': {
    fontSize: '14px',
    opacity: 0.9
  }
});

const links = [
  {
    category: 'Funeral Arrangements & Planning',
    items: [
      { name: 'National Funeral Directors Association (NFDA)', url: 'https://www.nfda.org/' },
      { name: 'Ever Loved', url: 'https://www.everloved.com/' }
    ]
  },
  {
    category: 'Trusts, Wills, & Probate',
    items: [
      { name: 'FreeWill', url: 'https://www.freewill.com/' },
      { name: 'Nolo – Probate & Estate Administration', url: 'https://www.nolo.com/legal-encyclopedia/probate' }
    ]
  },
  {
    category: 'Repatriation (Sending a Deceased Body to Ethiopia)',
    items: [
      { name: 'Ethiopian Embassy – Repatriation Guidelines', url: 'https://ethiopianembassy.org/services/repatriation/' },
      { name: 'Funeral Shipping Services', url: 'https://www.internationalmortuaryshipping.com/' },
      { name: 'Ethiopian Airlines Cargo', url: 'https://www.ethiopianairlines.com/corporate/group/cargo/' }
    ]
  }
];

const Footer = () => {
  return (
    <BlueSection component="footer">
      <div>
        <Box display="flex" justifyContent="space-between" sx={{ px: { xs: 2, sm: 4, md: 6 } }}>
          <Typography fontSize={{ xs: '12px', md: '16px', xl: '24px' }} textAlign="center" variant="h3">ሃምሳ ሎሚ ለአንድ ሰው ሸክሙ ለሃምሳ ሰው ግን ጌጡ ነው።</Typography>
          <Typography fontSize={{ xs: '12px', md: '16px', xl: '24px' }} textAlign="center" variant="h3">A single twig breaks, but the bundle of twigs is strong.</Typography>
        </Box>
        <BlueGrid container spacing={4}>
          <Grid item xs={12} md={12}>
            <BlueBox>
              <Typography textAlign="center" variant="h3">Helpful Links</Typography>
              <Grid container spacing={4}>
                {links.map((section, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                      {section.category}
                    </Typography>
                    <ul style={{ padding: 0 }}>
                      {section.items.map((item, idx) => (
                        <li style={{ color: '#FF7F50' }} key={idx}>
                          <a href={item.url} style={{ color: '#FF7F50' }} target="_blank" rel="noopener noreferrer" color="primary" underline="hover">
                            {item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </Grid>
                ))}
              </Grid>
            </BlueBox>
          </Grid>
          <Grid item xs={12}>
            <Stack mt={6} width="100%" alignItems="center">
              <Typography
                sx={{
                  color: 'white !important',
                  whiteSpace: { xs: 'normal', sm: 'nowrap' },
                  textAlign: 'center',
                }}
              >
                © 2026 HamsaLomi Association. All rights reserved. Powered by{' '}
                <a
                  href="https://solutions.adacloudtech.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'inherit' }}
                >
                  ADACloudTech Solutions
                </a>
              </Typography>
            </Stack>
          </Grid>
        </BlueGrid>
      </div>
    </BlueSection>
  );
};

export default Footer;
